import { PERMISSIONS, ROUTE_PATHS } from "../../../PermissionsConstants";
import { ScorecardReportDaily } from "../ScorecardReport/ScorecardReportDaily";
import { ScorecardReportClosed } from "../ScorecardReport/ScorecardReportClosed";
import { ScorecardReportOpen } from "../ScorecardReport/ScorecardReportOpen";
export const ScorecardSideBar = [
  {
    title: "Scorecard Report (Daily)",
    to: ROUTE_PATHS.ScorecardDaily_Reports_Index,
    component: ScorecardReportDaily,
    permission:
      PERMISSIONS.permission_report_scorecard_scorecardreportsdaily_view,
  },
  {
    title: "Daily Scorecard Report (Closed)",
    to: ROUTE_PATHS.ScorecardClosed_Reports,
    component: ScorecardReportClosed,
    permission:
      PERMISSIONS.permission_report_scorecard_scorecardreportsclosed_view,
  },
  {
    title: "Open Scorecards >14 days",
    to: ROUTE_PATHS.ScorecardOpen_Reports,
    component: ScorecardReportOpen,
    permission:
      PERMISSIONS.permission_report_scorecard_scorecardreportsopen_view,
  },
];
